export default __webpack_public_path__ + "static/media/servico.26b49304.svg";